import ErrorBoundary from './components/ErrorBoundary';
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import useAuthStore from './store/authStore';

import Landing           from './pages/Landing';
import Login             from './pages/Login';
import Register          from './pages/Register';
import ForgotPassword    from './pages/ForgotPassword';
import ResetPassword     from './pages/ResetPassword';
import AcceptInvite      from './pages/AcceptInvite';
import Dashboard         from './pages/Dashboard';
import BotControl        from './pages/BotControl';
import Wallet            from './pages/Wallet';
import Pricing           from './pages/Pricing';
import Settings          from './pages/Settings';
import TradeHistory      from './pages/TradeHistory';
import WithdrawalHistory from './pages/WithdrawalHistory';
import CollectionHistory from './pages/CollectionHistory';
import Developer from './pages/Developer';
import Admin             from './pages/Admin';
import Referral          from './pages/Referral';

const PrivateRoute = ({ children }) => {
  const { token } = useAuthStore();
  return token ? children : <Navigate to="/login"/>;
};

const PublicRoute = ({ children }) => {
  const { token } = useAuthStore();
  return !token ? children : <Navigate to="/dashboard"/>;
};

export default function App() {
  return (
    <BrowserRouter>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background : '#1a1a1a',
            color      : '#fff',
            border     : '1px solid #2a2a2a',
          }
        }}
      />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={
          <PublicRoute><Login /></PublicRoute>
        }/>
        <Route path="/register" element={
          <PublicRoute><Register /></PublicRoute>
        }/>
        <Route path="/forgot-password" element={
          <PublicRoute><ForgotPassword /></PublicRoute>
        } />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/accept-invite" element={<AcceptInvite />} />
        <Route path="/dashboard" element={
          <PrivateRoute><Dashboard /></PrivateRoute>
        }/>
        <Route path="/bot" element={
          <PrivateRoute><BotControl /></PrivateRoute>
        }/>
        <Route path="/wallet" element={
          <PrivateRoute><ErrorBoundary><Wallet /></ErrorBoundary></PrivateRoute>
        }/>
        <Route path="/trades" element={
          <PrivateRoute><TradeHistory /></PrivateRoute>
        }/>
        <Route path="/withdrawals" element={
          <PrivateRoute><WithdrawalHistory /></PrivateRoute>
        }/>
        <Route path="/collections" element={
          <PrivateRoute><CollectionHistory /></PrivateRoute>
        }/>
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/settings" element={
          <PrivateRoute><Settings /></PrivateRoute>
        }/>
        <Route path="/developer" element={<Developer/>}/>
          <Route path="/admin" element={
          <PrivateRoute><Admin /></PrivateRoute>
        }/>
        <Route path="/referral" element={
          <PrivateRoute><Referral /></PrivateRoute>
        }/>
        <Route path="*" element={<Navigate to="/"/>}/>
      </Routes>
    </BrowserRouter>
  );
}
